import { createFileRoute } from '@tanstack/react-router'

import { exportReportDocument } from '@/components/report-viewer/export'
import { LotStockReport } from '@/components/reports/lot-stock/lot-stock-report'
import { lotStockTitle } from '@/components/reports/lot-stock/lot-stock-documents'
import { validateLotStockSearch } from '@/components/reports/lot-stock/lot-stock-search'
import { ReportPage } from '@/components/reports/report-page'
import { useAuth } from '@/hooks/use-auth'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/reports/sorting-stock',
)({
    validateSearch: validateLotStockSearch,
    component: LotStockReportPage,
})

function LotStockReportPage() {
    const search = Route.useSearch()
    const navigate = Route.useNavigate()
    const { hasPermission } = useAuth()
    return (
        <ReportPage title={lotStockTitle('sorting')}>
            <LotStockReport
                kind="sorting"
                search={search}
                onSearchChange={(next) =>
                    void navigate({
                        search: (prev) => ({ ...prev, ...next }),
                        replace: true,
                    })
                }
                exportDocument={
                    hasPermission('reports.export')
                        ? exportReportDocument
                        : undefined
                }
            />
        </ReportPage>
    )
}
